import type { DeckDef } from "@/decks/types";

// Deck ejecutivo de avance del proyecto SOTA × Talleres Lucas.
// Mover una slide = mover su línea. Ocultarla = hidden: true. El motor deriva
// numeración y progreso del orden. Todo el texto vive en messages/es.json bajo
// deck.avance.* y es editable desde el admin (pestaña Traducciones).
export const avanceDeck: DeckDef = {
  id: "avance",
  listed: true,
  languages: ["es"],
  slides: [
    {
      id: "portada",
      load: () => import("./slides/PortadaSlide"),
    },
    {
      id: "resumen",
      load: () => import("./slides/ResumenSlide"),
      fragments: 4,
    },
    {
      id: "cronograma",
      load: () => import("./slides/CronogramaSlide"),
    },
    {
      id: "proximos-pasos",
      load: () => import("./slides/ProximosPasosSlide"),
    },
    {
      id: "integracion",
      load: () => import("./slides/IntegracionSlide"),
    },
    {
      id: "cierre",
      load: () => import("./slides/CierreSlide"),
    },
  ],
};
